import { useThemeMode } from '../contexts/ThemeContext';
import { useAuth } from './useAuth';
import { THEMES } from '../theme/themes';

/**
 * Returns whether the UI should render in dark mode.
 * Accounts for both system preference AND theme's isDarkTheme flag.
 *
 * Use this instead of manually checking `mode === 'dark'` in components.
 */
export const useEffectiveDark = () => {
  const { mode } = useThemeMode();
  const { user } = useAuth();

  const themeKey = user?.theme?.toLowerCase();
  const userTheme = themeKey ? THEMES[themeKey] : null;

  return mode === 'dark' || userTheme?.isDarkTheme || false;
};

/**
 * Returns effectiveDark for a specific child (not the logged-in user).
 * Use when rendering cards for multiple children.
 */
export const getEffectiveDarkForChild = (child, systemIsDark) => {
  const themeKey = child?.theme?.toLowerCase();
  const childTheme = themeKey ? THEMES[themeKey] : null;
  return systemIsDark || childTheme?.isDarkTheme || false;
};

/**
 * Returns the child's theme object if they have a premium theme.
 */
export const getChildTheme = (child) => {
  const themeKey = child?.theme?.toLowerCase();
  return themeKey ? THEMES[themeKey] : null;
};
